//  TYPES HERE
export const SET_LOADING = 'SET_LOADING';   
export const SET_MINI_LOADING = 'SET_MINI_LOADING';   

// Auth
export const SET_COUNTRY = 'SET_COUNTRY';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const HANDLE_INPUT_ON_CHANGE = 'HANDLE_INPUT_ON_CHANGE';
export const HANDLE_SELECT_COUNTRY = 'HANDLE_SELECT_COUNTRY';
export const CLEAR_AUTH = 'CLEAR_AUTH';
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';

//  QUIZ
export const SET_MODAL = 'SET_MODAL';
export const GET_TRIVIA_CREDENTIALS = 'GET_TRIVIA_CREDENTIALS';
export const HANDLE_SETUP_QUIZ_INPUT = 'HANDLE_SETUP_QUIZ_INPUT';
export const HANDLE_SETUP_QUIZ_SELECT = 'HANDLE_SETUP_QUIZ_SELECT';
export const CLEAR_SETUP_QUIZ = 'CLEAR_SETUP_QUIZ';
export const SET_QUESTIONS_DATA = 'SET_QUESTIONS_DATA';
export const GET_CURRENT_QUESTION = 'GET_CURRENT_QUESTION';
export const GET_QUIZ_RESULTS = 'GET_QUIZ_RESULTS';
export const SET_COUNTER = 'SET_COUNTER';
export const SAVED_SUCCESS = 'SAVED_SUCCESS';



